import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ApiService } from '../../../services/api.service';

@Component({
  selector: 'app-product-management',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './product-management.component.html',
  styleUrls: ['./product-management.component.css']
})
export class ProductManagementComponent implements OnInit {
  products: any[] = [];
  categories: any[] = [];
  showAddForm = false;
  editingProduct: any = null;
  productForm = {
    name: '',
    category: '',
    description: '',
    unit: ''
  };
  errorMessage = ''; // Error notification message

  constructor(private apiService: ApiService) {}

  ngOnInit() {
    this.loadCategories();
    this.loadProducts();
  }

  loadCategories() {
    this.apiService.getCategories().subscribe({
      next: (data) => {
        this.categories = data;
      }
    });
  }

  loadProducts() {
    // Fetch all products (using large limit to get all products)
    this.apiService.getProducts(1, 1000).subscribe({
      next: (response) => {
        // Handle paginated response
        this.products = response.products || (Array.isArray(response) ? response : []);
      },
      error: (err) => {
        console.error('Error loading products:', err);
        this.products = [];
      }
    });
  }

  saveProduct() {
    if (this.editingProduct) {
      this.apiService.updateProduct(this.editingProduct._id, this.productForm).subscribe({
        next: () => {
          this.loadProducts();
          this.cancelEdit();
        },
        error: (err) => {
          this.showErrorNotification(err.error?.message || 'Error updating product');
        }
      });
    } else {
      this.apiService.createProduct(this.productForm).subscribe({
        next: () => {
          this.loadProducts();
          this.cancelEdit();
        },
        error: (err) => {
          this.showErrorNotification(err.error?.message || 'Error creating product');
        }
      });
    }
  }

  editProduct(product: any) {
    this.editingProduct = product;
    this.productForm = {
      name: product.name,
      category: product.category._id || product.category,
      description: product.description || '',
      unit: product.unit || ''
    };
    this.showAddForm = true;
  }

  deleteProduct(id: string) {
    if (confirm('Are you sure you want to delete this product?')) {
      this.apiService.deleteProduct(id).subscribe({
        next: () => {
          this.loadProducts();
        },
        error: (err) => {
          this.showErrorNotification(err.error?.message || 'Error deleting product');
        }
      });
    }
  }

  cancelEdit() {
    this.showAddForm = false;
    this.editingProduct = null;
    this.productForm = {
      name: '',
      category: '',
      description: '',
      unit: ''
    };
  }

  showErrorNotification(message: string) {
    this.errorMessage = message;
    // Auto-hide notification after 5 seconds
    setTimeout(() => {
      this.errorMessage = '';
    }, 5000);
  }
}






